export enum MAGIC_LINK {
    EMAIL_ME_LINK = 'MAGIC_LINK.EMAIL_ME_LINK',
    LINK_HAS_BEEN_SENT_TO = 'MAGIC_LINK.LINK_HAS_BEEN_SENT_TO',
    SIGN_IN_WITH_LINK = 'MAGIC_LINK.SIGN_IN_WITH_LINK',
}
